export const getIntegrationFields = (shortCode: string) => {
  const fields: {[key: string]: string[]} = {
    agentbox: ['access_token', 'client_id', 'office_id'],
    docusign: ['electronic_signature_integrable'],
    freshdesk: ['access_token', 'domain_name'],
    mydesktop: ['access_token'],
    reivforms: ['username', 'password'],
    rex: ['username', 'password'],
    vaultre: ['access_token'],
    zendesk: ['access_token', 'domain_name', 'username'],
  }

  return fields[shortCode] || []
}
export const BULK_ACTION_SERVICE_PROVIDERS = ['my_property_pass']

export type IntegrationPlatformField = {
  key: string,
  label: string,
  required: boolean,
  option_values?: { key: string, value: number | string }[],
}

type IntegrationPlaform = {
  key: string,
  title: string,
  data?: {
    fields: IntegrationPlatformField[],
  },
}

const integrationPlatforms: IntegrationPlaform[] = [
  { key: 'agentbox', title: 'Agentbox' },
  { key: 'campaign_agent', title: 'Campaign Agent' },
  { key: 'core_billing', title: 'Core Billing' },
  { key: 'core_logic', title: 'Core Logic' },
  { key: 'docusign', title: 'Docusign' },
  { key: 'domain_group', title: 'Domain Group' },
  { key: 'exavault', title: 'Exavault' },
  { key: 'facebook', title: 'Facebook' },
  { key: 'freshdesk', title: 'Freshdesk' },
  { key: 'google_maps', title: 'Google Maps' },
  { key: 'ljhooker_pwcs', title: 'LJ Hooker PWCS' },
  { key: 'mydesktop', title: 'MyDesktop' },
  { key: 'myob_advanced', title: 'MYOB Advanced' },
  { key: 'printco', title: 'Printco' },
  { key: 'rea', title: 'REA' },
  { key: 'realbase', title: 'Realbase' },
  { key: 'rex', title: 'Rex' },
  { key: 'vaultre', title: 'VaultRE' },
  { key: 'xero', title: 'Xero' },
  { key: 'youtube', title: 'Youtube' },
  { key: 'zendesk', title: 'Zendesk' },
  { key: 'zuora', title: 'Zuora' },
]

export default integrationPlatforms
